import { render, staticRenderFns } from "./LayoutContentHeader.vue?vue&type=template&id=3bee6494&"
import script from "./LayoutContentHeader.vue?vue&type=script&lang=js&"
export * from "./LayoutContentHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports